export const TEMPORARY_MAXIMUM_AMOUNT_REMOVE_WHEN_API_INTEGRATED = 22500.0;

export const US_STATES_ID = 3;
export const KASHU_PRIVACY_POLICY_URL =
	"https://kashupay.com/main-page/privacy-policy";
export const KASHU_TERMS_OF_SERVICE_URL =
	"https://kashupay.com/main-page/terms-of-service";
export const KASHU_USER_AGREEMENT_URL =
	"https://kashupay.com/main-page/user-agreement";
export const KASHU_CONTACT_SUPPORT_URL = "https://help.kashupay.com";

export const PAYOVA_CONTACT_SUPPORT_URL = "https://help.payova.biz";
export const PAYOVA_TERMS_OF_SERVICE_URL = "https://payova.biz/legal-hub";

export enum CC_TOKEN_TYPE {
	CREDIT_CARD = 1,
	BANK_ACCOUNT = 2,
}

export const LOCAL_STORAGE_KEYS = {
	CLEARME_SESSION_TOKEN: "CLEARME_SESSION_TOKEN",
	// Add more keys as needed
} as const;

export const BANK_ACCOUNT_STATEMENT =
	"Your financial information is encrypted and fully protected";

export const PHONE_NUMBER_STATEMENT =
	"We never share your phone number with third parties";

export const MIN_TRANSFER = 1500 as const;
/** Minimum USD amount for transfer out (withdraw). */
export const MIN_TRANSFER_OUT = 1 as const;
/** Maximum USD amount for transfer in (CC in / deposit). */
export const MAX_TRANSFER_IN = 25000 as const;
/** Maximum USD amount for ACH transfer out (withdraw). */
export const MAX_TRANSFER_OUT = 50000 as const;
